export default class SaveManager {
  constructor(objectManager, colorPalette, gridLarge, gridSmall, objectSection, previewWindowContainer) {
    this.maxBackup = 20;
    this._objectManager = objectManager;
    this._colorPalette = colorPalette;
    this._gridLarge = gridLarge;
    this._gridSmall = gridSmall;
    this._objectSection = objectSection;
    this._previewWindowContainer = previewWindowContainer;
  }
  async loadPXARCH(file, isAdding = false) {
    return new Promise((ok, ng) => {
      const reader = new FileReader;
      reader.onload = () => {
        const worker = new Worker(new URL('workers/readPXARCH.js', import.meta.url), {type: 'module'});
        worker.onmessage = e => {
          this._objectManager.restore(e.data.objectManager, isAdding);
          if(!isAdding) {
            this._colorPalette.restore(e.data.colorPalette);
            this._gridLarge.restore(e.data.gridLarge);
            this._gridSmall.restore(e.data.gridSmall);
          }
          this._objectSection.reset(this._objectManager.getObjectsLength());
          this._previewWindowContainer.clear();
          ok();
        };
        worker.onerror = ng;
        worker.postMessage(reader.result);
      }
      reader.readAsArrayBuffer(file);
    });
  }
  async backupPXARCH() {
    const blob = await this.createPXARCH();
    const db = await this._openDB();
    const objectStore = db.transaction('backup', 'readwrite').objectStore('backup');

    let count = await new Promise(ok => {
      const req = objectStore.count();
      req.onsuccess = e => ok(e.target.result);
    });
    await new Promise(ok => {
      const req = objectStore.openCursor();
      req.onsuccess = e => {
        const cursor = e.target.result;
        if(cursor && count >= this.maxBackup) {
          cursor.delete().onsuccess = () => {
            --count;
            cursor.continue();
          };
        } else {
          ok();
        }
      };
    });

    const date = new Date;
    return new Promise(ok => {
      const req = objectStore.add({date, blob});
      req.onsuccess = e => ok(e.target.result);
    });
  }
  async getBackupDates() {
    const db = await this._openDB();
    const objectStore = db.transaction('backup').objectStore('backup');
    return new Promise(ok => {
      const req = objectStore.getAllKeys();
      req.onsuccess = e => ok(e.target.result);
    });
  }
  async loadBackup(date) {
    const db = await this._openDB();
    const objectStore = db.transaction('backup').objectStore('backup');
    const blob = await new Promise(ok => {
      const req = objectStore.get(date);
      req.onsuccess = e => ok(e.target.result.blob);
    });
    return this.loadPXARCH(blob);
  }
  async createPXARCH() {
    return new Promise((ok, ng) => {
      const worker = new Worker(new URL('workers/createPXARCH.js', import.meta.url), {type: 'module'});
      worker.onmessage = e => {
        ok(e.data);
      }
      worker.onerror = e => {
        ng(e);
      }
      const message = {
        objectManager: this._objectManager.save(),
        colorPalette: this._colorPalette.save(),
        gridLarge: this._gridLarge.save(),
        gridSmall: this._gridSmall.save(),
      };
      worker.postMessage(message);
    });
  }
  async _openDB() {
    return new Promise((ok, ng) => {
      const req = indexedDB.open('PixelArch', 1);
      req.onerror = ng;
      req.onupgradeneeded = e => {
        const db = e.target.result;
        const objectStore = db.createObjectStore('backup', {keyPath: 'date'});
      };
      req.onsuccess = e => {
        const db = e.target.result;
        db.onerror = ng;
        ok(db);
      }
    });
  }
}
